import {
  MakeReadyStatus,
  surface_core__api__entities__MoveIn as MoveIn,
  Task,
} from "api-client";
import { DrawerWorkItems } from "./drawer-work-items";
import {
  ApplicationProgressDetail,
  AssigneeDetail,
  AvailabilitySummaryDetail,
  ChargesDetail,
  Detail,
  LeaseSummaryDetails,
  PersonsDetail,
  PetsDetail,
  UnitDetail,
  VehiclesDetail,
} from "../ui/drawer-details";
import { DrawerHeaderContainer } from "./drawer-header-container";
import ActionBar from "./action-bar/action-bar";

export const MoveInDrawerContent = ({
  item,
  task,
  isLoading,
  onClickResident,
}: {
  task?: Partial<Task>;
  item?: MoveIn;
  isLoading?: boolean;
  onClickResident?: (
    propertyId: string,
    residentId: string,
    name?: string | null
  ) => void;
}) => {
  return (
    <div className="flex flex-col">
      <DrawerHeaderContainer>
        <DrawerWorkItems task={task} isLoading={isLoading} />
        <ActionBar task={task} />
      </DrawerHeaderContainer>
      <div className="flex flex-col space-y-4 py-4 px-6">
        <AssigneeDetail
          isLoading={isLoading}
          label="Assigned to"
          value={task?.assigned_to}
          className="mb-4"
        />
        <hr />
        <UnitDetail
          label="Unit"
          value={task?.unit_summary}
          isLoading={isLoading}
        />
        <hr />
        <AvailabilitySummaryDetail
          isLoading={isLoading}
          label="Availability"
          value={{
            available_date: task?.unit_summary?.available_date,
            move_in_date: item?.application_summary?.move_in_date,
            make_ready_status: task?.unit_summary
              ?.make_ready_status as MakeReadyStatus | null,
          }}
        />
        <hr />
        <PersonsDetail
          label="Residents"
          isLoading={isLoading}
          value={task?.residents?.map((x) => {
            return {
              name: x.full_name,
              phone_number: x.phone_number,
              email_address: x.email_address,
              onClick: () => {
                if (x.id && task.property_id) {
                  onClickResident?.(task.property_id, x.id, x.full_name);
                }
              },
              // age: x.age,
            };
          })}
        />
        <hr />
        <Detail
          label="Leasing agent"
          isLoading={isLoading}
          value={item?.application_summary?.leasing_agent?.full_name}
        />
        <hr />
        <Detail
          label="Application type"
          isLoading={isLoading}
          value={item?.application_summary?.application_type}
        />
        <hr />
        <PetsDetail label="Pets" value={task?.pets} isLoading={isLoading} />
        <hr />
        <VehiclesDetail
          label="Vehicles"
          value={task?.vehicles}
          isLoading={isLoading}
        />
        <hr />
        <LeaseSummaryDetails
          label="Lease"
          value={task?.lease_summary}
          isLoading={isLoading}
        />
        <hr />
        <ChargesDetail
          isLoading={isLoading}
          label="Charges"
          value={task?.lease_summary?.recurring_charges}
        />
        <hr />
        <ApplicationProgressDetail
          isLoading={isLoading}
          label="Application progress"
          value={item?.application_summary?.status_changes}
        />
        <hr />
        <Detail
          label="Application ID"
          value={item?.application_summary?.id}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};
